var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicrophone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00018 0C9.65679 0 10.307 0.129329 10.9136 0.380602C11.5202 0.631876 12.0714 1.00017 12.5357 1.46447C13 1.92876 13.3683 2.47995 13.6196 3.08658C13.8708 3.69321 14.0002 4.34339 14.0002 5V9C14.0002 10.3261 13.4734 11.5979 12.5357 12.5355C11.598 13.4732 10.3263 14 9.00018 14C7.67409 14 6.40232 13.4732 5.46464 12.5355C4.52696 11.5979 4.00018 10.3261 4.00018 9V5C4.00018 3.67392 4.52696 2.40215 5.46464 1.46447C6.40232 0.526784 7.67409 0 9.00018 0ZM0.0551758 10H2.07018C2.31247 11.6648 3.14605 13.1867 4.41841 14.2873C5.69077 15.3879 7.31685 15.9936 8.99918 15.9936C10.6815 15.9936 12.3076 15.3879 13.5799 14.2873C14.8523 13.1867 15.6859 11.6648 15.9282 10H17.9442C17.7168 12.0287 16.8068 13.9199 15.3634 15.3635C13.92 16.8071 12.0289 17.7174 10.0002 17.945V22H8.00018V17.945C5.97131 17.7176 4.07996 16.8074 2.63635 15.3638C1.19274 13.9202 0.282588 12.0289 0.0551758 10Z",
    fill: "#09121F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrophone);
export default __webpack_public_path__ + "static/media/microphone.8c8fc64b1492c0817d5bd986311102fb.svg";
export { ForwardRef as ReactComponent };